import React from 'react';
import { connect } from 'react-redux';
import { getRoleOfSignedInUser } from '../../redux/reducers';

const ConnectedRoleBasedComponent = ({ role, ...props }) => (
  <React.Fragment>{props.render(role)}</React.Fragment>
);

const mapStateToProps = (state) => ({
  role: getRoleOfSignedInUser(state),
});

const WithRole = connect(mapStateToProps)(ConnectedRoleBasedComponent);

export default WithRole;
